import { computed } from 'vue';
import { PROMO_TYPES_MAP_BY_TEXT, WITH_CODE } from '../constants';

export const usePromoType = ({
  priceTypeText,
  priceFlags,
} = {}) => {
  function _getPromoType() {
    if (priceFlags?.value?.isWithOfferPromo) {
      // With code promo has the highest priority
      return WITH_CODE;
    }

    return PROMO_TYPES_MAP_BY_TEXT[priceTypeText.value] || '';
  }

  const promoType = computed(_getPromoType);
  const isEmptyPromoType = computed(() => promoType.value === '');

  return {
    isEmptyPromoType,
    promoType,
  };
};

export default usePromoType;
